import { Player } from "@lottiefiles/react-lottie-player";
import editorStyle from "../../reportWriter.module.css";
import loading from "../../../../../../assets/loading2.json";

interface Props {
  id: number;
}

function GeneratingSection({ id }: Readonly<Props>) {
  return (
    <div className={editorStyle.vulnWrapper}>
      <div className={editorStyle.generatingTextBox}>
        <h4 className={editorStyle.generatingText}>
          Vulnerability <span className={editorStyle.blueText}>#{id}</span> is being generated
        </h4>
        <div className={editorStyle.animationWrapper}>
          <Player autoplay loop src={loading} className={editorStyle.lottie} />
        </div>
      </div>
    </div>
  );
}

export default GeneratingSection;
